// maincategory
export const ADD_MIANCATEGORY = "ADD_MAINCATEGORY"
export const ADD_MIANCATEGORY_RED = "ADD_MAINCATEGORY_RED"
export const GET_MIANCATEGORY = "GET_MAINCATEGORY"
export const GET_MIANCATEGORY_RED = "GET_MAINCATEGORY_RED"
export const UPDATE_MIANCATEGORY = "UPDATE_MAINCATEGORY"
export const UPDATE_MIANCATEGORY_RED = "UPDATE_MAINCATEGORY_RED"
export const DELETE_MIANCATEGORY = "DELETE_MAINCATEGORY"
export const DELETE_MIANCATEGORY_RED = "DELETE_MAINCATEGORY_RED"

// subcategory
export const ADD_SUBCATEGORY = "ADD_SUBCATEGORY"
export const ADD_SUBCATEGORY_RED = "ADD_SUBCATEGORY_RED"
export const GET_SUBCATEGORY = "GET_SUBCATEGORY"
export const GET_SUBCATEGORY_RED = "GET_SUBCATEGORY_RED"
export const UPDATE_SUBCATEGORY = "UPDATE_SUBCATEGORY"
export const UPDATE_SUBCATEGORY_RED = "UPDATE_SUBCATEGORY_RED"
export const DELETE_SUBCATEGORY = "DELETE_SUBCATEGORY"
export const DELETE_SUBCATEGORY_RED = "DELETE_SUBCATEGORY_RED"

// brend
export const ADD_BRAND = "ADD_BRAND"
export const ADD_BRAND_RED = "ADD_BRAND_RED"
export const GET_BRAND = "GET_BRAND"
export const GET_BRAND_RED = "GET_BRAND_RED"
export const UPDATE_BRAND = "UPDATE_BRAND"
export const UPDATE_BRAND_RED = "UPDATE_BRAND_RED"
export const DELETE_BRAND = "DELETE_BRAND"
export const DELETE_BRAND_RED = "DELETE_BRAND_RED"

// product
export const ADD_PRODUCT = "ADD_PRODUCT"
export const ADD_PRODUCT_RED = "ADD_PRODUCT_RED"
export const GET_PRODUCT = "GET_PRODUCT"
export const GET_PRODUCT_RED = "GET_PRODUCT_RED"
export const UPDATE_PRODUCT = "UPDATE_PRODUCT"
export const UPDATE_PRODUCT_RED = "UPDATE_PRODUCT_RED"
export const UPDATE_PRODUCT_QUANTITY = "UPDATE_PRODUCT_QUANTITY"
export const UPDATE_PRODUCT_QUANTITY_RED = "UPDATE_PRODUCT_RED_QUANTITY"
export const DELETE_PRODUCT = "DELETE_PRODUCT"
export const DELETE_PRODUCT_RED = "DELETE_PRODUCT_RED"

// testimonial
export const ADD_TESTIMONIAL = "ADD_TESTIMONIAL"
export const ADD_TESTIMONIAL_RED = "ADD_TESTIMONIAL_RED"
export const GET_TESTIMONIAL = "GET_TESTIMONIAL"
export const GET_TESTIMONIAL_RED = "GET_TESTIMONIAL_RED"
export const UPDATE_TESTIMONIAL = "UPDATE_TESTIMONIAL"
export const UPDATE_TESTIMONIAL_RED = "UPDATE_TESTIMONIAL_RED"
export const DELETE_TESTIMONIAL = "DELETE_TESTIMONIAL"
export const DELETE_TESTIMONIAL_RED = "DELETE_TESTIMONIAL_RED"

// cart
export const ADD_CART = "ADD_CART"
export const ADD_CART_RED = "ADD_CART_RED"
export const GET_CART = "GET_CART"
export const GET_CART_RED = "GET_CART_RED"
export const UPDATE_CART = "UPDATE_CART"
export const UPDATE_CART_RED = "UPDATE_CART_RED"
export const DELETE_CART = "DELETE_CART"
export const DELETE_CART_RED = "DELETE_CART_RED"

// checkout
export const ADD_CHECKOUT = "ADD_CHECKOUT"
export const ADD_CHECKOUT_RED = "ADD_CHECKOUT_RED"
export const GET_CHECKOUT = "GET_CHECKOUT"
export const GET_CHECKOUT_RED = "GET_CHECKOUT_RED"
export const UPDATE_CHECKOUT = "UPDATE_CHECKOUT"
export const UPDATE_CHECKOUT_RED = "UPDATE_CHECKOUT_RED"
export const DELETE_CHECKOUT = "DELETE_CHECKOUT"
export const DELETE_CHECKOUT_RED = "DELETE_CHECKOUT_RED"

// wishlist
export const ADD_WISHLIST = "ADD_WISHLIST"
export const ADD_WISHLIST_RED = "ADD_WISHLIST_RED"
export const GET_WISHLIST = "GET_WISHLIST"
export const GET_WISHLIST_RED = "GET_WISHLIST_RED"
export const UPDATE_WISHLIST = "UPDATE_WISHLIST"
export const UPDATE_WISHLIST_RED = "UPDATE_WISHLIST_RED"
export const DELETE_WISHLIST = "DELETE_WISHLIST"
export const DELETE_WISHLIST_RED = "DELETE_WISHLIST_RED"

// newsletter
export const ADD_NEWSLETTER = "ADD_NEWSLETTER"
export const ADD_NEWSLETTER_RED = "ADD_NEWSLETTER_RED"
export const GET_NEWSLETTER = "GET_NEWSLETTER"
export const GET_NEWSLETTER_RED = "GET_NEWSLETTER_RED"
export const UPDATE_NEWSLETTER = "UPDATE_NEWSLETTER"
export const UPDATE_NEWSLETTER_RED = "UPDATE_NEWSLETTER_RED"
export const DELETE_NEWSLETTER = "DELETE_NEWSLETTER"
export const DELETE_NEWSLETTER_RED = "DELETE_NEWSLETTER_RED"

// contact_us
export const ADD_CONTACT_US = "ADD_CONTACT_US"
export const ADD_CONTACT_US_RED = "ADD_CONTACT_US_RED"
export const GET_CONTACT_US = "GET_CONTACT_US"
export const GET_CONTACT_US_RED = "GET_CONTACT_US_RED"
export const UPDATE_CONTACT_US = "UPDATE_CONTACT_US"
export const UPDATE_CONTACT_US_RED = "UPDATE_CONTACT_US_RED"
export const DELETE_CONTACT_US = "DELETE_CONTACT_US"
export const DELETE_CONTACT_US_RED = "DELETE_CONTACT_US_RED"